import { PayoutMethodEnum } from "enum/common";
import { ReactComponent as PayoutPaypal } from "assets/PayoutPaypal.svg";
import { ReactComponent as PayoutVenmo } from "assets/PayoutVenmo.svg";
import { ReactComponent as PayoutCheck } from "assets/PayoutCheck.svg";
import { ReactComponent as PayoutCanada } from "assets/PayoutCanada.svg";
import { ReactComponent as PayoutZelle } from "assets/PayoutZelle.svg";
import { useMemo } from "react";
import RadioField from "components/FormFields/RadioField";
import { PayoutModalPropsType } from "components/PayoutManagement/types";

interface IPayoutOptions {
  onSelect: (method: PayoutMethodEnum) => void;
  paymentModal: PayoutModalPropsType;
  isBusinessInCanada: boolean;
}

const Payoutoptions: React.FC<IPayoutOptions> = ({
  onSelect,
  paymentModal,
  isBusinessInCanada,
}) => {
  const payoutMethods = useMemo(() => {
    const commonMethods = [
      { icon: PayoutPaypal, name: "Paypal", method: PayoutMethodEnum.PAYPAL },
      { icon: PayoutVenmo, name: "Venmo", method: PayoutMethodEnum.VENMO },
      { icon: PayoutZelle, name: "Zelle", method: PayoutMethodEnum.ZELLE },
    ];
    if (isBusinessInCanada) {
      commonMethods.push({
        icon: PayoutCanada,
        name: "EFT (Canada)",
        method: PayoutMethodEnum.CANADA_EFT,
      });
    } else {
      commonMethods.push({
        icon: PayoutCheck,
        name: "Check (US)",
        method: PayoutMethodEnum.CHECK,
      });
    }

    return commonMethods;
  }, [isBusinessInCanada]);

  const payoutOptions = payoutMethods?.map((method) => {
    return {
      label: (
        <div
          key={method.method}
          className="flex gap-3 cursor-pointer"
          onClick={() => onSelect(method?.method)}
        >
          <div>{<method.icon width={20} height={20} />}</div>
          <div>{method.name}</div>
        </div>
      ),
      value: method.method,
    };
  });

  return (
    <div className="flex gap-4">
      <RadioField
        value={paymentModal?.method}
        containerClass="grid md:grid-cols-2 grid-cols-1 w-full"
        options={payoutOptions}
        name={"payout-method"}
        onChange={(value: any) => {
          const payoutMethod = value;
          onSelect(payoutMethod?.value);
        }}
      />
    </div>
  );
};

export default Payoutoptions;
